import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins'
import './assets/scss/main.scss'
import filters from './utils/filters'
import './utils/SentryUtil'
import 'amfe-flexible/index.js'
import preventReClick from './utils/preventReClick'
import { SMSLogin } from 'lingdongliang-module'
import Message from 'lingdongliang-module/lib/Message'

Vue.use(Message)
Vue.use(SMSLogin)
Vue.config.productionTip = false

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

new Vue({
  router,
  store,
  preventReClick,
  render: h => h(App)
}).$mount('#app')
